import React from 'react';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';
import { formatDateUS } from '@libs/ui/components/job/utils';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface RequisitionInfoAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const RequisitionInfoAccordion: React.FC<
  RequisitionInfoAccordionProps
> = ({ jobData, expanded, onChange }) => {
  const classes = useStyles();

  // Use actual data from striive job schema
  const striive_job = jobData.striive_job;
  const getValue = (val: any) =>
    val !== undefined && val !== null && val !== '' ? val : 'N/A';

  const mappedData = {
    submittedBy: striive_job
      ? getValue(striive_job.coordinator_full_name)
      : 'N/A',
    createdDate: striive_job ? formatDateUS(striive_job.created_at) : 'N/A',
    duration: striive_job ? getValue(striive_job.estimated_total_hours) : 'N/A',
    hoursPerDay: striive_job ? getValue(striive_job.hours_per_day) : 'N/A',
    responseDeadline: striive_job
      ? formatDateUS(striive_job.closing_date_client)
      : 'N/A',
    category: striive_job ? getValue(striive_job.department) : 'N/A',
  };

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion
      title="REQUISITION INFORMATION"
      expanded={expanded}
      onChange={onChange}
    >
      <Grid container spacing={3}>
        {renderDetailItem('Submitted By:', mappedData.submittedBy)}
        {renderDetailItem('Created Date:', mappedData.createdDate)}
        {renderDetailItem('Total Duration In Hours:', mappedData.duration)}
        {renderDetailItem('Hours Per Day:', mappedData.hoursPerDay)}
        {renderDetailItem('Response Deadline:', mappedData.responseDeadline)}
        {renderDetailItem('Category:', mappedData.category)}
      </Grid>
    </JobAccordion>
  );
};
